import React, { useEffect, useState } from "react";
import { getPrivacyPolicy } from "./privacyTermApi";
import { Container } from "@mui/material";
import SEO from "../../common/SEO";

export const PrivacyPolicy = () => {
  const [documentContent, setDocumentContent] = useState("");
  const getPrivacyPolicyData = () => {
    getPrivacyPolicy((data) => {
      console.log("Data privacy policy", data);
      setDocumentContent(data);
    });
  };

  useEffect(() => {
    getPrivacyPolicyData();
  }, []);

  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/privacyPolicy"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Container>
        <div dangerouslySetInnerHTML={{ __html: documentContent }} />
      </Container>
    </>
  );
};
